import configMeasurements, { allMeasures } from 'convert-units'

const convert: ReturnType<typeof configMeasurements> = configMeasurements(allMeasures)

export function convertArea(
  value: number | null | undefined,
  fromUnit?: string | null,
  toUnit?: string | null,
): number | null {
  if (value == null || value === undefined) return null

  if (!fromUnit || !toUnit || fromUnit === toUnit) return value

  try {
    return convert(value)
      .from(fromUnit as any)
      .to(toUnit as any)
  } catch {
    // rollback to original value if we could not convert it
    return value
  }
}
